var favouritesForm = document.querySelectorAll('.favourites-form');

favouritesForm.forEach((el) => {
	$form = el;
	submitButton = el.querySelector('.favourites-form__submit');
	let data = new FormData($form);

	submitButton.addEventListener('click', function () {
		this.preventDefault;
		fetch('/', {
			method: 'post',
			body: data,
			headers: {
				Accept: 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
		}).then(function (response) {
			response.json().then(function (data) {
				console.log(data);
			});
		});
	});
});
